// extracted by mini-css-extract-plugin
export default {"noEmployees":"EmployeeList_noEmployees__qexG7","employeeContainer":"EmployeeList_employeeContainer__k0I2-"};